export const pluck = <T extends object, K extends keyof T>(
  data: T[],
  key: K,
): T[K][] => data.map((item) => item[key]);

export const uniq = <T>(arr: T[]) => arr.filter((elm, i, self) => self.indexOf(elm) === i);
